<template>
  <div v-if="isFloatingMenuVariant">
    <div 
      v-if="!showNewMenuModal"
      @click="triggerMenuModal"
      class="floating-menu"
      :class="{ 'move-up': cartQuantity > 0 }"
    >
      <div>
        <img src="../../../default/images/global/dominos-logo.svg" class="pd8" />
      </div>
      <div class="flex-column">
        <span class="floating-menu-heading mt2">View Menu</span>
        <span class="floating-menu-items">{{getTotalNumberOfItems}} items</span>
      </div>
    </div>

    <!-- menu popup -->
    <new-menu-modal
      v-if="isSeparateMenuVariant && showNewMenuModal"
    >
    </new-menu-modal>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import {
  keyMapsGetter,
  keyMapsMutation
} from "../helpers/storeKeys";
import userActivityTracking from "../helpers/UserActivityTracking";
import Utility from "../helpers/utility";
import PageNames from "../config/pageNames";
import setEvents from "../helpers/events";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS
} from "../config/vwoKeys";

export default {
  name: "FloatingMenu",
  components: {
    NewMenuModal: defineAsyncComponent(() =>
      import("./BottomBarNewMenuModal.vue")
    ),
  },
  data() {
    return {
      showMenuModal: false,
    }
  },
  mounted() {
    // console.log("FLOATING MENU MOUNTED");
  },
  methods: {
    eventFunction(isClicked = false, eObj = {}, eventName = "") {
      let eventType = isClicked ? "Click" : "Impression";
      if (eventName) {
        eventType = eventName;
      }
      let userAction = isClicked ? "click" : "impression";
      let preEventObj = { ...eObj };
      let sectionPosition = preEventObj["sectionPosition"];
      delete preEventObj["sectionPosition"];
      const eventObj = Utility.amplitudeEventObj(
        userAction,
        preEventObj["sectionName"],
        sectionPosition,
        preEventObj
      );
      setEvents("amplitude", eventType, eventObj);
    },
    triggerMenuModal(e) {
      let menuArray = [];
      menuArray = Object.keys(this.getBottomBarData).map(item => item.toLowerCase()).filter(item => item != "recommendations");
      let _ = (this.productCounterString && !this.productCounterString.startsWith('undefined')) ? this.productCounterString : "";
      let tempCategory = _ ? _.split("|")[0].replace("Showing", "").trim().toLowerCase() : "";

      this.eventFunction(true, {
        positionWithinSection: -1,
        sectionName: "floating menu",
        category: "open", 
        subCategory: "open", 
        // subSection: "bottom menu",
        screenName: PageNames.NEXTGEN_MENUPAGE,
        sectionPosition:"-1"
      });

      document.body.classList.add("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_NEW_MENU_MODAL_FLAG, true);
      this.$store.commit(keyMapsMutation.UPDATE_MENU_MODAL_FLAG_OPENED_FROM, "bottom menu");

      //Amplitude impression event load
      this.eventFunction(false, {
        sectionName: "floating menu",
        // subSection: "bottom menu",
        positionWithinSection: -1,
        screenName: PageNames.NEXTGEN_MENUPAGE,
        menuCategories: menuArray,
        sectionPosition:"-1",
        menuCount:menuArray?.length
      });
      userActivityTracking.menuOpen(0);
    },
  },
  computed: {
    getTotalNumberOfItems() {
      return this.$store.getters[keyMapsGetter.GET_PRODUCT_ITEMS_IN_ONE_ARRAY]?.length;
    },
    isSeparateMenuVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_X
      ) {
        return true;
      } else {
        return false;
      }
    },
    getBottomBarData() {
      return this.$store.state.ProductItems.productItems;
    },
    productCounterString() {
      return this.$store.state.ProductItems.productCounterString;
    },
    showNewMenuModal() {
      return this.$store.state.Menu.showMenuModalFlag;
    },
    isFloatingMenuVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_X
      ) {
        return true;
      } else {
        return false;
      }
    },
    cartQuantity() {
      return this.$store.getters[keyMapsGetter.CART_QUANTITY];
    },
  }

}
</script>

<style>

</style>
